module.exports = __webpack_public_path__ + "img/IMG_2049.ad2a6166.jpg";